import { useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "@axum/ax-design";
import { RootState } from "../types/store";

const FILTER_LISTS = ["leaders", "supervisors", "sellers", "origins", "states", "channels", "clients", "operationTypes"] as const;

export const useOrdersFailed = () => useSelector((state: RootState) => !state.orders.success);

export const useSellerStatsFailed = () => useSelector((state: RootState) => !state.sellersStats.success);

const useFilterListsFailed = () => useSelector((state: RootState) => FILTER_LISTS.some(list => !state[list].success));

const useFailureToast = (failed: boolean, message: string) => {
  useEffect(() => {
    if (failed) toast.show(message, { type: "danger" });
  }, [failed, message]);
};

export const useLoadErrorToasts = () => {
  useFailureToast(useOrdersFailed(), "No se pudieron traer los pedidos");
  useFailureToast(useSellerStatsFailed(), "No se pudieron traer los vendedores");
  useFailureToast(useFilterListsFailed(), "No se pudieron traer las opciones de los filtros");
};
